
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IDeferredPromise, newDeferredPromise } from '../../helpers/promise';
import { lsTest } from '../../helpers/localstorage';
import CookieBanner from './CookieBanner.vue';
// eslint-disable-next-line import/no-cycle
import CookieBannerPlugin from './cookieBannerPlugin';
import { EventBus } from '../../eventbus';

@Component({
	name: 'CookieBannerContainer',
	components: { CookieBanner }
})
export default class CookieBannerContainer extends Vue {
	@Prop({ type: Boolean, required: true }) readonly hasInteracted!: boolean;

	@Prop({
		type: String,
		required: false,
		validator: (value: string) => ['user', 'company'].includes(value)
	})
	readonly mode?: String;

	@Prop({ type: Boolean, default: false }) readonly forceOpen!: boolean;

	waitTillUserHasInteractedPromise: IDeferredPromise | undefined;

	showCookieBanner = this.forceOpen;

	isOpen = false;

	stage: 'overview' | 'config' = 'overview';

	beforeMount() {
		CookieBannerPlugin.event.$on('toggle', this.toggle);
	}

	@Watch('hasInteracted')
	watchHasInteracted(newVal) {
		if (newVal && this.waitTillUserHasInteractedPromise) {
			this.waitTillUserHasInteractedPromise.resolve();
		}
	}

	async waitTillUserHasInteracted() {
		if (this.hasInteracted) {
			return;
		}

		if (!this.waitTillUserHasInteractedPromise) {
			this.waitTillUserHasInteractedPromise = newDeferredPromise();
		}
		await this.waitTillUserHasInteractedPromise?.promise;
	}

	mounted() {
		// only trigger the cookie banner when page load event has been fired
		this.winLoad(async () => {
			if (this.$route.meta?.showCookieBanner !== 'false' && this.needsToAcceptCookies()) {
				// wait till the user has interacted with the page
				await this.waitTillUserHasInteracted();
				EventBus().$emit('showCookieBanner');
				this.$emit('show');
			}
		});
	}

	winLoad(callback) {
		if (document.readyState === 'complete' || document.readyState === 'interactive') {
			callback();
		} else {
			window.addEventListener('load', callback);
		}
	}

	needsToAcceptCookies(): boolean {
		if (lsTest()) {
			const acceptedCookies = localStorage.getItem('accept-cookies');
			// user has already accepted cookies -> load tracking
			if (acceptedCookies) {
				window.acceptedTracking?.();
			}
			return !acceptedCookies;
		}
		return false; // don't show cookieBanner if it can't be stored anyway
	}

	toggle(open = true, params?) {
		if (params) {
			if (params?.stage === 'config') {
				this.stage = 'config';
			}
		}
		if (open) {
			this.showCookieBanner = true;
			this.$emit('show');
		} else {
			this.showCookieBanner = false;
			window.acceptedTracking?.();
			this.$emit('hide');
		}
	}

	preventClick(e) {
		e?.preventDefault();
	}

	beforeDestroy() {
		CookieBannerPlugin.event.$off('toggle', this.toggle);
	}
}
